import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind classes with clsx semantics — resolves conflicts intelligently.
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
